document.addEventListener('DOMContentLoaded', function () {
  const storageKey = 'recentlyViewedProducts';
  const maxItems = 4;

  const recentlyViewedContainer = document.querySelector('[data-recently-viewed-container]');

  const getStoredProducts = () => {
    try {
      return JSON.parse(localStorage.getItem(storageKey)) || [];
    } catch (e) {
      return [];
    }
  };

  const saveProducts = (products) => {
    localStorage.setItem(storageKey, JSON.stringify(products));
  };

  const renderRecentlyViewed = () => {
    if (!recentlyViewedContainer) return;

    const products = getStoredProducts();

    if (!products.length) {
      recentlyViewedContainer.innerHTML = '';
      return;
    }

    recentlyViewedContainer.innerHTML = products.slice(0, maxItems).map(item => `
      <a href="${item.url}" class="rv-card" style="display:block;text-decoration:none;color:inherit;">
        <div class="rv-card__image" style="background:#fff;aspect-ratio:3/4;display:flex;align-items:center;justify-content:center;overflow:hidden;">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy" style="width:100%;height:100%;object-fit:contain;display:block;">` : ''}
        </div>
        <div class="rv-card__title" style="margin-top:10px;font-size:13px;line-height:1.45;">
          ${item.title}
        </div>
      </a>
    `).join('');
  };

  const isProductPage = document.body.classList.contains('template-product');

  if (isProductPage) {
    const title =
      document.querySelector('h1')?.textContent?.trim() || document.title;

    const url = window.location.pathname;

    const image =
      document.querySelector('.product__media img, .product-media img, .product__modal-opener img, .featured-media img')?.src || '';

    if (title && url) {
      let products = getStoredProducts();

      products = products.filter(item => item.url !== url);

      products.unshift({
        title,
        url,
        image
      });

      products = products.slice(0, maxItems);
      saveProducts(products);
    }
  }

  renderRecentlyViewed();
});